module.exports = {"id":"dp2_4l3q4","text":"Collaborating through Digital Technologies","instructions":"When working in a digital group, how should different perspectives be handled?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_4l3q4-a1","text":"Considered to reach shared goals","score":3.7},{"id":"dp2_4l3q4-a2","text":"Ignored to save time","score":1.3},{"id":"dp2_4l3q4-a3","text":"Handled only by leaders","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.4"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.4/l3q4.json
// module id = 1053
// module chunks = 41